module.exports = __webpack_public_path__ + "logo_sogetrel.png?d8461015c792966714cddebb4a4f18df";


//////////////////
// WEBPACK FOOTER
// ./src/img/confiance/logo_sogetrel.png
// module id = 175
// module chunks = 0